import type { FetchNextPageOptions, InfiniteData } from '@tanstack/react-query';
import type { PaginatedResponse } from 'v5/api/_common/query/pagination';

/**
 * A list read page by page, as a service hands it out: the pages, whether there is a next one,
 * whether a read is in flight, and the way to ask for the next. Nothing that reloads it.
 */
export type RemoteInfiniteData<TPage> = {
  data: InfiniteData<TPage, number> | undefined;
  hasNextPage: boolean;
  isFetching: boolean;
  fetchNextPage: (options?: FetchNextPageOptions) => Promise<unknown>;
};

/**
 * `getNextPageParam` of a list whose pages are 0-based and whose every response carries the
 * total `count`: the next page while the pages read so far hold fewer rows than the count.
 */
export function paginatedResponseGetNextPageParam(
  lastPage: PaginatedResponse<unknown>,
  lastPageParam: number,
  pageSize: number
): number | undefined {
  const loadedCount = (lastPageParam + 1) * pageSize;
  return loadedCount < lastPage.count ? lastPageParam + 1 : undefined;
}
